import { Header, LogoPrimaryCP, LogoBadgetCP, Drawer, ProfileNav, NavbarVertical, Button } from '@consumidor-positivo/aurora';

import { useCpHeader } from './hook';
import './styles.scss';

interface LoggedInHeaderProps {
  username?: string;
}

export const CpHeader: React.FC<LoggedInHeaderProps> = ({ username }) => {
  const { dataSourceNavbar, dataSourceNavbarVertical, drawerOpen, firstName, handleOpenDrawer, handleNavigate } = useCpHeader();

  return (
    <div className="cp-header">
      <Header.Root>
        <Header.Button onClick={() => handleNavigate('/inicio', 'Dashboard')}>
          <Header.Logo renderDesktop={<LogoPrimaryCP />} renderMobile={<LogoBadgetCP />} />
        </Header.Button>
        <Header.Navigation>
          <Header.Navbar
            data={dataSourceNavbar}
            renderItem={(item) => (
              <Header.NavbarLink key={item.name} active={item.active} name={item.name} dropdown={item.dropdown} onClick={item.onClick} />
            )}
          />
          <Header.Actions divider>
            <Header.Profile onClickMenu={() => handleOpenDrawer('menu')} fullName={username || ''} />
          </Header.Actions>
        </Header.Navigation>

        <Drawer
          isOpen={drawerOpen.menu}
          handleOpen={() => handleOpenDrawer('menu')}
          renderHeader={<ProfileNav name={firstName(username || '')} fullName={username || ''} />}
          renderContent={
            <NavbarVertical
              data={dataSourceNavbarVertical}
              renderItem={(link) => {
                return (
                  <NavbarVertical.Link
                    key={link.name}
                    active={link.active}
                    Icon={link.Icon}
                    name={link.name}
                    dropdown={link.dropdown}
                    onClick={() => {
                      handleOpenDrawer('menu');
                      link.onClick?.();
                    }}
                  />
                );
              }}
              renderActions={() => (
                <div className="cp-header__actions">
                  <Button type="outlined" expand="x" onClick={() => handleNavigate('/sair', 'Sair')}>
                    Sair
                  </Button>
                </div>
              )}
            />
          }
        />
      </Header.Root>
    </div>
  );
};
